import React from 'react';
import { IconButton } from '@mui/material';
import { Clear } from '@mui/icons-material';
import { useFilters } from '@Map/esri/features/useFilters';
import { useGlobalization } from '@Translations/useGlobalization';
import {
	FilterCardContainer,
	FilterCardTextContainer,
} from './FilterCard.styles';

export const FilterCard = (): JSX.Element | null => {
	const { t } = useGlobalization();
	const { filterCount, clearFilters } = useFilters();

	if (!filterCount) return null;

	const label =
		filterCount > 1
			? t('filters active', { context: 'Filter Card' })
			: t('filter active', { context: 'Filter Card' });

	return (
		<FilterCardContainer className="filterCardContainer">
			<FilterCardTextContainer className="filterCardTextContainer">
				{`${filterCount} ${label}`}
			</FilterCardTextContainer>
			<IconButton
				className="filterCardResetButton"
				size="small"
				onClick={clearFilters}>
				<Clear fontSize="small" />
			</IconButton>
		</FilterCardContainer>
	);
};
